import styles from '../index.module.css'

import React, { useState } from 'react'
import type { Business } from 'types/public-playlist'
import { Box, Flex, Text, Button, RadioGroup } from 'components/ds'
import LoadingIndicator from 'components/ui/loading-indicator'
import Logo from 'components/ui/logo'
import type { State } from '../types'
import BusinessList from './business-list'

type Props = {
  businesses: Array<Business>
  onClose: (event: React.SyntheticEvent<HTMLButtonElement>) => void
  onSave: (_business: Business) => void
  state: State
  currentBusinessId: number
}

const AddToDiscoBusinessList = ({
  businesses,
  onClose,
  onSave,
  state,
  currentBusinessId,
}: Props): React.ReactNode => {
  const { status, error } = state

  // Find the first non-current business as default
  const defaultBusiness =
    businesses.find(b => b.id !== currentBusinessId) || businesses[0]
  const [selectedBusinessId, setSelectedBusinessId] = useState<string>(
    defaultBusiness?.id?.toString() || '',
  )

  const handleSave = () => {
    const selectedBusiness = businesses.find(
      b => b.id.toString() === selectedBusinessId,
    )
    if (selectedBusiness) {
      onSave(selectedBusiness)
    }
  }

  const handleClose = (event: React.SyntheticEvent<HTMLButtonElement>) => {
    setSelectedBusinessId(defaultBusiness?.id?.toString() || '')
    onClose(event)
  }

  const isLoading = status === 'LOADING' || status === 'ADDING'

  return (
    <Box className={styles.AddToDiscoModal_Container}>
      {status === 'LOADING' ? (
        <div className={styles.AddToDiscoModal_LoadingContainer}>
          <LoadingIndicator />
        </div>
      ) : (
        <Flex
          direction="column"
          gap="4"
          className={styles.AddToDiscoModal_BusinessList}
          data-dont-close-formats-dropdown
        >
          <Flex justify="center" py="3" className={styles.AddToDiscoModal_Logo}>
            <Logo />
          </Flex>
          <Box px="5">
            <Text size="2">
              Choose the business you&apos;d like to add this music to
            </Text>
          </Box>
          <RadioGroup.Root
            value={selectedBusinessId}
            onValueChange={setSelectedBusinessId}
          >
            <Flex direction="column">
              {businesses?.map(business => (
                <BusinessList
                  key={business.id}
                  business={business}
                  isCurrentBusiness={currentBusinessId === business.id}
                />
              ))}
            </Flex>
          </RadioGroup.Root>
          {status === 'ERROR' && error && (
            <Box px="5">
              <Text size="2" color="red">
                Error: {error.message}
              </Text>
            </Box>
          )}
          <Flex gap="3" justify="end" px="5" pb="1">
            <Button
              variant="soft"
              color="gray"
              onClick={handleClose}
              disabled={isLoading}
            >
              Cancel
            </Button>
            <Button onClick={handleSave} disabled={isLoading}>
              {status === 'ADDING' ? 'Saving...' : 'Save'}
            </Button>
          </Flex>
        </Flex>
      )}
    </Box>
  )
}

export default AddToDiscoBusinessList
